
import { SpecialEvent } from '../../types/specialEvent';
import { skills } from '../skills';

export const marketOpportunityEvent: SpecialEvent = {
  id: 'market-opportunity',
  title: 'Unique Market Opportunity',
  description: 'A unique opportunity has emerged in the mining market. How will you capitalize on it?',
  type: 'opportunity',
  triggerYears: [5, 10, 14], // Special opportunities at milestone years
  options: [
    {
      text: 'Expand into new geographic markets',
      outcome: 'You extend your operations into previously untapped regions.',
      roleSpecificOutcome: [
        {
          roleId: 'entrepreneur',
          outcome: 'Your entrepreneurial instincts lead you to regions with exceptional conditions for mining.',
          kpiEffects: {
            energyCost: -0.007,
            profitMargin: 6
          },
          experienceGain: 40
        },
        {
          roleId: 'energy',
          outcome: 'You identify regions with exceptionally low energy costs.',
          kpiEffects: {
            energyCost: -0.01,
            efficiency: 3
          },
          experienceGain: 35
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'strategic-planning',
          outcome: 'Your strategic planning ensures your expansion leverages regional advantages perfectly.',
          kpiEffects: {
            profitMargin: 7,
            efficiency: 4
          },
          experienceGain: 45
        }
      ],
      kpiEffects: {
        energyCost: -0.003,
        profitMargin: 3,
        uptime: -1
      },
      experienceGain: 30
    },
    {
      text: 'Offer mining services to institutions',
      outcome: 'You pivot to providing hosted mining services for institutional clients.',
      roleSpecificOutcome: [
        {
          roleId: 'operations',
          outcome: 'Your operational excellence impresses institutional clients, leading to long-term contracts.',
          kpiEffects: {
            uptime: 4,
            profitMargin: 5
          },
          experienceGain: 35
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'negotiation',
          outcome: 'Your negotiation skills secure premium rates from institutional clients.',
          kpiEffects: {
            profitMargin: 8,
            efficiency: 2
          },
          experienceGain: 40
        },
        {
          skillId: 'investor-relations',
          outcome: 'Your investor relations expertise helps build valuable institutional partnerships.',
          kpiEffects: {
            profitMargin: 7,
            uptime: 3
          },
          experienceGain: 45
        }
      ],
      kpiEffects: {
        profitMargin: 4,
        uptime: 2,
        efficiency: -1
      },
      experienceGain: 25,
      skillUnlock: skills.find(s => s.id === 'investor-relations')
    },
    {
      text: 'Integrate vertically in the supply chain',
      outcome: 'You acquire components of your supply chain to reduce costs and dependencies.',
      roleSpecificOutcome: [
        {
          roleId: 'entrepreneur',
          outcome: 'Your business acumen helps you identify and acquire undervalued supply chain assets.',
          kpiEffects: {
            energyCost: -0.005,
            profitMargin: 7
          },
          experienceGain: 45
        }
      ],
      skillSpecificOutcome: [
        {
          skillId: 'supply-chain',
          outcome: 'Your supply chain expertise leads to exceptional synergies after vertical integration.',
          kpiEffects: {
            efficiency: 5,
            profitMargin: 6
          },
          experienceGain: 40
        }
      ],
      kpiEffects: {
        energyCost: -0.002,
        efficiency: 3,
        profitMargin: -2
      },
      experienceGain: 30,
      skillUnlock: skills.find(s => s.id === 'supply-chain')
    }
  ]
};
